import { useIxmUserauthV1TenantQueryServiceTenantGet } from '../generated/hooks/ixm-userauth-v1-tenant-query-service-tenant-get';
import { useProgramMetaAccessSelector } from './program-auth-access-selector';

export function useGetProgramTenant(
  request: Parameters<typeof useIxmUserauthV1TenantQueryServiceTenantGet>[0],
  options?: Parameters<typeof useIxmUserauthV1TenantQueryServiceTenantGet>[1],
  withAccess?: Parameters<typeof useIxmUserauthV1TenantQueryServiceTenantGet>[2],
) {
  const programMetaAccess = useProgramMetaAccessSelector(request?.tenantId);

  return useIxmUserauthV1TenantQueryServiceTenantGet(request, options, withAccess ?? programMetaAccess);
}
